import { Component, Input, Output, EventEmitter } from '@angular/core';
import { SharedModule } from 'src/app/private/shared/shared.module';
import { StudentOverviewComponent } from "../student-overview/student-overview.component";
import { StudentTransportComponent } from "../student-transport/student-transport.component";
import { StudentHostelComponent } from "../student-hostel/student-hostel.component";
import { StudentFeesComponent } from "../student-fees/student-fees.component";
import { StudentAttendanceComponent } from "../student-attendance/student-attendance.component";
import { LeadService } from 'src/app/private/services/lead.service';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';

interface StudentDetails {
  student_id?: string;
  first_name?: string;
  last_name?: string;
  email?: string;
  phone?: string;
  date_of_birth?: string;
  gender?: string;
  course?: { name: string };
  department?: { name: string };
  batch?: { batch_name: string };
  academic_year?: { year_name: string };
  registration_date?: string;
  attendance?: {
    present_days: number;
    absent_days: number;
    percentage: number;
  };
  fees?: {
    total_amount: number;
    paid_amount: number;
    due_amount: number;
    next_due_date: string;
  };
  hostel?: {
    name: string;
    room_number: string;
  };
  transport?: {
    route_number: string;
    vehicle_number: string;
  };
  dynamic_fields?: { [key: string]: any };
}

@Component({
  selector: 'app-student-profile-middle-screen',
  standalone: true,
  imports: [SharedModule, StudentOverviewComponent, StudentTransportComponent, StudentHostelComponent, StudentFeesComponent, StudentAttendanceComponent],
  templateUrl: './student-profile-middle-screen.component.html',
  styleUrl: './student-profile-middle-screen.component.scss'
})
export class StudentProfileMiddleScreenComponent {

  @Input() studentDetails: StudentDetails = {};
  @Input() selectedTabIdx: any = 0;
  @Output() tabChanged = new EventEmitter<number>();

  @Input() allLeadFeilds: any[] = [];
  @Input() fieldValues: any = {};

  @Input() allCourses: any[] = [];
  @Input() batchList: any[] = [];
  @Input() academicYearList: any[] = [];
  @Input() feeCategoryList: any[] = [];
  @Input() departmentList: any[] = [];

  @Input() hostelCategoryList: any[] = [];
  @Input() scholarshipTypeList: any[] = [];
  @Input() transportRouteList: any[] = [];

  constructor(
    private api: LeadService,
    private localStorage: LocalStorageService
  ) { }

  ngOnInit() {
    this.getLeadsFields();
  }

  getLeadsFields() {
    let param = {
      organization_id: this.localStorage.getOrganizationId(),
      module_type: 'student'
    };
    this.api.getLeadsFields(param).subscribe({
      next: (data) => {
        this.allLeadFeilds = data?.fields.sort((a: any, b: any) => a.sequence - b.sequence);
        this.fieldValues = this.studentDetails?.dynamic_fields || {};
        console.log("Dynamic fields loaded for student:", this.allLeadFeilds);
      },
      error: (error) => {
        console.error("Error loading dynamic fields:", error);
      }
    });
  }

  tabs = [
    { label: 'Overview', key: 'overview' },
    { label: 'Attendance', key: 'attendance' },
    { label: 'Exams', key: 'exams' },
    { label: 'Time Table', key: 'timetable' },
    { label: 'Fees', key: 'fees' },
    { label: 'Library Details', key: 'library' },
    { label: 'Documents', key: 'documents' },
    { label: 'Hostel', key: 'hostel' },
    { label: 'Transport', key: 'transport' }
  ];

  selectTab(index: any) {
    console.log('Selected Tab Index:', index);
    this.selectedTabIdx = index;
    this.tabChanged.emit(index);
  }

  handleUpdate(updatedDetails: any) {
    console.log('Updated Student Details:', updatedDetails);
  }
}
